import { Component, Input, OnChanges, SimpleChanges, OnDestroy, OnInit } from '@angular/core';
import pdfMake, { TCreatedPdf } from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { fillColor, hLineColor, vLineColor, quitVLineColor } from '../pdf/helpers';
import { mantenance, personalSecure, protectPlus, secure, substitute, textNotes, tracking } from './txts';

import moment from 'moment';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DEFAULT_NAME_QUOTER } from 'src/app/pages/buro/pages/identidad/constants';
import { CotizadorService } from 'src/app/services/cotizador.service';
import { ICreditAmotization } from 'src/app/pages/buro/interfaces/ICreditAmortization';
import { InsuranceIdToName, InsuranceTypeIDsEnum, MONTHS, SUSTITUECAROPTSHASH } from 'src/app/utils/utils';
import { Content, TDocumentDefinitions, Table, TableCell, TableLayout } from 'pdfmake/interfaces';
import { DataService } from 'src/app/services/data.service';
import { Router } from '@angular/router';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-pdf-credit',
  templateUrl: `./pdf-credit.component${environment.templateSuffix}.html`,
  styleUrls: ['./pdf-credit.component.scss'],
})
export class PdfCreditComponent implements OnDestroy, OnChanges, OnInit {
  @Input() dataQuoter!: any;
  @Input() deadlineSelect!: any;
  @Input() stateSelected!: any;
  @Input() insuranceSelected!: any;
  @Input() car!: any;
  @Input() show: boolean = true;
  @Input() donwloadAtumatic: boolean = false;
  @Input() name: string = DEFAULT_NAME_QUOTER;
  public isLoading: boolean = false;

  private urlEncode64 = require('../../../mocks/logo.json');
  private quoterDate: string = moment().format('DD/MM/YYYY');

  private pdfOpen?: TCreatedPdf;
  private tipColor = `${environment.templateSuffix === '' ? '#fe5000' : '#f15c22'
    }`;
  private colorGrey = '#ececec';
  private border1 = [true, true, false, false];
  private border2 = [true, false, false, false];
  private border3 = [true, false, false, true];
  private border4 = [true, true, true, true];

  private formatter = new Intl.NumberFormat('es-MX');
  /* 'TRADITIONAL' | 'BALLON' */
  private tableAmortization: ICreditAmotization[] = [];

  private destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private cotizadorService: CotizadorService,
    private dataService: DataService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.dataService.getDownloadPdfCredit().subscribe(({ data, quoterId, period, concept, pwi }) => {
      const { deadlineSelect, stateSelected, insuranceSelected, car, dataQuoter } = data;
      this.deadlineSelect = {
        ...deadlineSelect,
        idQuoter: quoterId,
        period,
        concept
      };
      this.stateSelected = stateSelected;
      this.insuranceSelected = insuranceSelected;
      this.car = { ...car, priceWithIva: pwi };
      this.dataQuoter = dataQuoter;
      this.createPdf();
    });
  }

  ngOnChanges(_: SimpleChanges): void {
    if (this.donwloadAtumatic) {
      this.createPdf();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  async createPdf() {
    this.isLoading = true;
    this.cotizadorService
      .getCreditAmortization(
        this.deadlineSelect.idQuoter,
        this.deadlineSelect.period,
        this.deadlineSelect.concept
      ).subscribe((table) => {
        this.tableAmortization = table;
        this.isLoading = false;
        this.loadPdf();
      });
  }

  loadPdf() {
    const pdfDefinition: TDocumentDefinitions = {
      pageMargins: [40, 80, 40, 60],
      header: this.getHeader(),
      content: [
        this.getQuoteHeaders(),
        this.getAmortizationPayment(),
        {
          style: 'tableExample',
          table: {
            body: this.getBodyDetails(),
          },
          layout: 'lightHorizontalLines',
        },
        {
          style: 'tableExample',
          table: {
            body: this.getBodyNotes(),
          },
          layout: 'lightHorizontalLines',
        },
      ],
      styles: {
        header: {
          fontSize: 10,
          bold: true,
          alignment: 'justify',
        },
        tableFirst: {
          fontSize: 8,
          margin: [0, 0, 0, 10],
        },
        tableExample: {
          fontSize: 8,
          margin: [0, 5, 0, 10],
        },
        tableTitle: {
          fontSize: 8,
          margin: [1, 0, 0, 0],
          bold: true,
          alignment: 'center',
        },
        alingCenter: {
          alignment: 'center',
        },
        tableBody: {
          fontSize: 8,
          margin: [0, 0, 0, 10],
        },
        tableHeader: {
          bold: true,
          fontSize: 9,
          color: 'black',
        },
        negritas: {
          bold: true,
        },
        headerTable: {
          bold: true,
          background: this.tipColor,
          alignment: 'center',
        },
      },
      info: {
        title: this.name,
      },
    };
    this.pdfOpen = pdfMake.createPdf(pdfDefinition);
    this.openPdf();
  }

  private openPdf() {
    this.pdfOpen?.open();
    if (this.router.url.includes('download')) {
      this.router.navigate(['/home']);
    }
  }

  private getCellCss(
    text: string,
    color: string,
    fillColorCol: string,
    bold: boolean
  ) {
    return {
      text,
      color,
      fillColor: fillColorCol,
      bold,
    };
  }

  private getCellCssHeader(
    text: string,
    color: string,
    border: boolean[],
    fillColorCol: string,
    bold: boolean
  ) {
    return {
      border,
      text,
      color,
      fillColor: fillColorCol,
      bold,
    };
  }

  private getLayout(): TableLayout {
    return { hLineColor, vLineColor };
  }

  private getLayoutQuitLines(): TableLayout {
    return { vLineColor: quitVLineColor, hLineColor: '#ececec' };
  }

  private formatText(element: number) {
    return `$${this.formatter.format(element)}`;
  }

  private getHeader(): Content {
    const tableCells: TableCell[] = [
      {
        border: [false, false, false, false],
        fillColor: this.tipColor,
        image: `data:image/png;base64,${this.urlEncode64.logoUrlBase64}`,
        width: 110,
        height: 40,
        margin: [25, 10, 0, 10],
      },
    ];
    return [
      {
        table: {
          widths: '*',
          body: [tableCells],
        },
      },
    ];
  }

  private getQuoteHeaders(): Content {
    const leftTable: TableCell[][] = this.LeftQuoteHeader;
    const rightTable: TableCell[][] = this.RightQuoteHeader;
    const initPayTable: TableCell[][] = this.getBodyPagoInicial;
    return {
      columns: [
        {
          width: '*',
          style: 'tableFirst',
          layout: this.getLayout(),
          stack: [
            {
              layout: this.getLayout(),
              table: {
                widths: [90, 130],
                body: [
                  ...leftTable,
                ],
              }
            },
            {
              text: ' ', // Spacer element
              margin: [0, 3, 0, 3]
            },
            {
              layout: this.getLayout(),
              table: {
                widths: [90, 130],
                body: [
                  ...initPayTable,
                ],
              }
            }
          ]
        },

        {
          width: '*',
          style: 'tableFirst',
          layout: this.getLayout(),
          table: {
            widths: [90, 130],
            body: rightTable,
          },
        },
      ],
    };
  }

  /**
   * Función que obtiene el texto del seguro dependiendo del tipo de seguro
   * Deolvera el nombre del seguro si es anual contado o si es financiado devolvera tambien el monto.
   * @private
   * @return {*}  {string}
   * @memberof PdfCreditComponent
   * @author victor.mendez
   */
  private getInsuranceText(): string {
    const insuranceType = this.dataQuoter.insuranceType;
    const insuranceName = InsuranceIdToName[insuranceType as InsuranceTypeIDsEnum];

    if (
      insuranceType === InsuranceTypeIDsEnum.ANUAL_CONTADO_CON_PAGO_ANUAL ||
      insuranceType === InsuranceTypeIDsEnum.ANUAL_CONTADO_SIN_PAGO_ANUAL
    ) {
      return insuranceName;
    } else {
      return `${insuranceName} - ${this.formatText(this.deadlineSelect.lifeInsurance.insurance)}`;
    }
  }

  /**
   * Función que obtiene el total de los servicios de seguro
   * @private
   * @return {*}  {number}
   * @description Auto Sustituto + Rastreo base + Protección Plus
   * @memberof PdfCreditComponent
   * @author victor.mendez
   */
  private getInsuranceServices(): number {
    const { sustituteCar, gps, protectionPlus } = this.deadlineSelect.lifeInsurance;
    const total: number = (sustituteCar + gps + protectionPlus);
    return parseFloat(total.toFixed(2));
  }

  /**
   * Función que obtiene el total a financiar
   * @private
   * @return {*}  {number}
   * @memberof PdfCreditComponent
   * @author victor.mendez
   */
  private getTotalFinance(): number {
    const insuranceCost = this.calculateInsuranceCost();
    const insuranceAndServices = this.getInsuranceServices();
    const total = this.calculateTotalFinance(insuranceCost, insuranceAndServices);
    return parseFloat(total.toFixed(2));
  }

  private calculateInsuranceCost(): number {
    const insuranceType = this.dataQuoter.insuranceType;
    if (
      insuranceType === InsuranceTypeIDsEnum.ANUAL_CONTADO_CON_PAGO_ANUAL ||
      insuranceType === InsuranceTypeIDsEnum.ANUAL_CONTADO_SIN_PAGO_ANUAL
    ) {
      return 0;
    } else {
      return this.deadlineSelect.lifeInsurance.insurance;
    }
  }

  private calculateTotalFinance(insuranceCost: number, insuranceAndServices: number): number {
    return (this.car.priceWithIva - this.deadlineSelect.initialPaymentDetail.downPayment) + insuranceCost + insuranceAndServices;
  }

  private get LeftQuoteHeader(): TableCell[][] {
    const dateCell: TableCell[] = [
      this.getCellCssHeader(
        'Fecha',
        '#000',
        this.border1,
        this.colorGrey,
        false
      ),
      `${this.quoterDate}`,
    ];

    const vehicleCell: TableCell[] = [
      this.getCellCssHeader(
        'Vehículo',
        '#000',
        this.border2,
        this.colorGrey,
        false
      ),
      this.getHeaderVehiculo(),
    ];


    const productTypeCell: TableCell[] = [
      this.getCellCssHeader(
        `Producto `,
        '#000',
        this.border2,
        this.colorGrey,
        false
      ),
      this.deadlineSelect.concept === 'traditional'
        ? (!this.deadlineSelect.annuity || this.deadlineSelect.annuity === '') ? 'Crédito tradicional' : 'Crédito tradicional anualidades'
        : 'Crédito Balloon',
    ];

    const periodCell: TableCell[] = [
      this.getCellCssHeader(
        'Plazo Elegido',
        '#000',
        this.border2,
        this.colorGrey,
        false
      ),
      `${this.formatter.format(this.deadlineSelect.period)} meses`,
    ];

    const rateCell: TableCell[] = [
      this.getCellCssHeader('Tasa', '#000', this.border2, this.colorGrey, false),
      `${this.formatter.format(
        Number((this.deadlineSelect.finalRate.finalRate * 100).toFixed(2))
      )}%`,
    ];

    const cxaCell: TableCell[] = [
      this.getCellCssHeader(
        'Comisión por apertura',
        '#000',
        this.border2,
        this.colorGrey,
        false
      ),
      `${this.formatter.format(this.deadlineSelect.tasaFinalCxA * 100)}%`,
    ];

    const catCell: TableCell[] = [
      this.getCellCssHeader(
        'CAT sin IVA',
        '#000',
        this.border2,
        this.colorGrey,
        false
      ),
      `${this.formatter.format(Number((this.deadlineSelect.cat * 100).toFixed(2)))}%`,
    ];

    const lifeInsuranceCell = [
      this.getCellCssHeader(
        'Seguro Personal',
        '#000',
        this.border2,
        this.colorGrey,
        false
      ),
      `Incluido - ${this.formatText(this.deadlineSelect.lifeInsurance.annual.toFixed(2))}`,
    ];

    const monthlyPaymentCell: TableCell[] = [
      this.getCellCssHeader(
        'Pago mensual',
        '#ffffff',
        this.border3,
        this.tipColor,
        true
      ),
      this.getCellCss(this.formatText(this.deadlineSelect.monthlyPayment.toFixed(2)), '#000', '#fff', true)
    ];

    const leftTable: TableCell[][] = [
      dateCell,
      vehicleCell,
      productTypeCell,
      periodCell,
      rateCell,
      cxaCell,
      catCell,
      lifeInsuranceCell,
      monthlyPaymentCell,
    ];

    if (
      this.deadlineSelect.concept === 'traditional' &&
      this.dataQuoter.includeAnnuities
    ) {
      const annuityPaymentMonth = this.dataQuoter.annuityPaymentMonth;
      const spacialPayment = this.tableAmortization.find(
        ({ paymentDate }, index) => index > 0 && moment(paymentDate).month() === annuityPaymentMonth
      );
      if (spacialPayment) {
        const spacialPaymentsCell: TableCell[] = [
          this.getCellCssHeader(
            'Pagos especiales',
            '#000',
            this.border3,
            this.colorGrey,
            true
          ),
          `${this.formatText(spacialPayment.ordinaryPayment)} (${this.deadlineSelect.period / 12
          } pagos en ${MONTHS[annuityPaymentMonth]})`,
        ];
        leftTable.push(spacialPaymentsCell);
      }
    } else if (this.deadlineSelect.concept === 'BALLON') {
      const spacialPaymentsCell: TableCell[] = [
        this.getCellCssHeader(
          'Pagos especiales',
          '#000',
          this.border3,
          this.colorGrey,
          true
        ),
        `${this.formatText(
          this.tableAmortization[this.tableAmortization.length]
            .ordinaryPayment
        )} (último pago del crédito)`,
      ];

      leftTable.push(spacialPaymentsCell);
    }

    return leftTable;
  }

  private get RightQuoteHeader(): TableCell[][] {

    const vehiclePriceCell: TableCell[] = [
      this.getCellCssHeader(
        'Precio de Auto con IVA',
        '#000',
        this.border1,
        this.colorGrey,
        false
      ),
      `${this.formatText(this.car.priceWithIva.toFixed(2))}`,
    ];


    const downPaymentCell: TableCell[] = [
      this.getCellCssHeader(
        '(-) Enganche',
        '#000',
        this.border2,
        this.colorGrey,
        false
      ),
      `${this.formatText(this.deadlineSelect.initialPaymentDetail.downPayment.toFixed(2))}`,
    ];

    const insuranceStateCell: TableCell[] = [
      this.getCellCssHeader(
        'Entidad de seguro',
        '#000',
        this.border1,
        this.colorGrey,
        false
      ),
      `${this.stateSelected.stateName}`,
    ];


    const insuranceCell = [
      this.getCellCssHeader(
        'Aseguradora de Auto',
        '#000',
        this.border2,
        this.colorGrey,
        false
      ),
      `${this.insuranceSelected?.insurance?.key ?? 'Por confirmar'}`,
    ];

    const insuranceTypeCell = [
      this.getCellCssHeader(
        'Tipo de Seguro',
        '#000',
        this.border2,
        this.colorGrey,
        false
      ),
      this.getInsuranceText()
    ];


    const insuranceAndServicesCell = [
      this.getCellCssHeader(
        'Seguros y Servicios',
        '#000',
        this.border2,
        this.colorGrey,
        false
      ),
      ` ${this.formatText(this.getInsuranceServices())}`,
    ];


    const sustituteCarCell = [
      this.getCellCssHeader(
        'Auto Sustituto',
        '#000',
        this.border2,
        this.colorGrey,
        false
      ),
      this.getCellConditional(
        this.dataQuoter.substituteCar,
        `${SUSTITUECAROPTSHASH[`${this.dataQuoter.typeSustituteCar}`]
        } - ${this.formatText(this.deadlineSelect.lifeInsurance.sustituteCar)}`
      ),
    ];

    const gpsCell = [
      this.getCellCssHeader(
        'Rastreo Base',
        '#000',
        this.border2,
        this.colorGrey,
        false
      ),
      this.getCellConditional(this.dataQuoter.includeGps, this.deadlineSelect.lifeInsurance.gps),
    ];

    const protectionPlusCell = [
      this.getCellCssHeader(
        'Protección Plus',
        '#000',
        this.border2,
        this.colorGrey,
        false
      ),
      this.getCellConditional(
        this.dataQuoter.protectionPlus,
        this.deadlineSelect.lifeInsurance.protectionPlus
      ),
    ];


    const amountFinancedCell: TableCell[] = [
      this.getCellCssHeader(
        'Monto a financiar',
        '#fff',
        this.border3,
        this.tipColor,
        true
      ),
      {
        text: `${this.formatText(this.getTotalFinance())}`,
        style: 'tableHeader',
      }
    ];



    // const maintenanceCell = [
    //   this.getCellCssHeader(
    //     'Mantenimientos',
    //     '#000',
    //     this.border2,
    //     this.colorGrey,
    //     false
    //   ),
    //   this.getCellConditional(
    //     this.dataQuoter.includeMaintenance,
    //     this.deadlineSelect.maintenanceCost
    //   ),
    // ];

    // const maintenanceKmCell = [
    //   this.getCellCssHeader(
    //     'Kms Mantenimiento Incluido',
    //     '#000',
    //     this.border3,
    //     this.colorGrey,
    //     false
    //   ),
    //   `${this.dataQuoter.km}`,
    // ];
    const rightTable: TableCell[][] = [
      vehiclePriceCell,
      downPaymentCell,
      insuranceStateCell,
      insuranceCell,
      insuranceTypeCell,
      insuranceAndServicesCell,
      sustituteCarCell,
      gpsCell,
      protectionPlusCell,
      amountFinancedCell
    ];
    return rightTable;
  }

  private getCellConditional(condition: boolean, value: number | string) {
    const formatValue =
      typeof value === 'number' ? this.formatText(value) : value;
    return condition ? 'Incluido' : 'No Incluido';
  }

  private getHeaderVehiculo() {
    const brand = this.car.brand ? `${this.car.brand}` : '';
    const subBrand = this.car.subBrand ? `${this.car.subBrand}` : '';
    const version = this.car.version ? `${this.car.version}` : '';
    const year = this.car.year ? `${this.car.year}` : '';

    return `${brand} ${subBrand} ${version} ${year}`;
  }

  private getAmortizationPayment(): Content {
    return [
      {
        columns: [
          { width: '*', text: '' },
          {
            width: 'auto',
            style: 'tableTitle',
            table: {
              widths: [25, 75, 65, 65, 65, 65, 50, 65],
              body: [
                [
                  this.getCellCss('No. Pago', '#fff', this.tipColor, true),
                  this.getCellCss('Fecha de Pago', '#fff', this.tipColor, true),
                  this.getCellCss('Capital', '#fff', this.tipColor, true),
                  this.getCellCss('Interés', '#fff', this.tipColor, true),
                  this.getCellCss('IVA Interés', '#fff', this.tipColor, true),
                  this.getCellCss('Amortización', '#fff', this.tipColor, true),
                  this.getCellCss('Seguro Personal', '#fff', this.tipColor, true),
                  this.getCellCss(
                    'Pago Ordinario',
                    '#fff',
                    this.tipColor,
                    true
                  ),
                ],
              ],
            },
            alignment: 'center',
            layout: 'noBorders',
          },
          { width: '*', text: '' },
        ],
      },
      {
        columns: [
          { width: '*', text: '' },
          {
            width: 'auto',
            style: 'tableBody',
            table: {
              widths: [20, 70, 65, 65, 65, 65, 50, 60],
              body: this.getBodyMonths(),
            },
            layout: this.getLayoutQuitLines(),
            alignment: 'center'
          },
          { width: '*', text: '' },
        ],
      },
    ];
  }

  private get getBodyPagoInicial(): TableCell[][] {

    const tableCells: TableCell[][] = [
      [
        {
          text: 'Pago Inicial',
          colSpan: 2,
          alignment: 'center',
          fillColor: this.colorGrey,
          color: '#000',
          border: this.border4,
          bold: true,
        }, {},
      ],
      [
        this.getCellCss('Enganche', '#000', '#fff', false),
        `${this.formatText(
          this.deadlineSelect.initialPaymentDetail.downPayment.toFixed(2)
        )}`,
      ],
      [
        this.getCellCss('Comisión por apertura', '#000', '#fff', false),
        `${this.formatText(this.deadlineSelect.initialPaymentDetail.cxa.toFixed(2))}`,
      ],
    ];

    if (this.dataQuoter.insuranceType === InsuranceTypeIDsEnum.ANUAL_CONTADO_CON_PAGO_ANUAL || this.dataQuoter.insuranceType === InsuranceTypeIDsEnum.ANUAL_CONTADO_SIN_PAGO_ANUAL) {
      tableCells.push([
        this.getCellCss('Seguro de contado', '#000', '#fff', false),
        `${this.formatText(
          this.deadlineSelect.initialPaymentDetail.insurance.toFixed(2)
        )}`,
      ]);
    }

    const totalRow = [
      this.getCellCssHeader(
        'Total pago inicial',
        '#fff',
        this.border3,
        this.tipColor,
        true
      ),
      {
        text: this.formatText(this.deadlineSelect.initialPaymentDetail.total.toFixed(2)),
        style: 'tableHeader',
      },
    ];

    tableCells.push(totalRow);
    return tableCells;
  }

  private getBodyMonths() {
    const table: TableCell[][] = [];

    for (const tableRow of this.tableAmortization) {
      const {
        paymentDate,
        paymentNumber,
        capital,
        interest,
        interestWithIva,
        amortization,
        lifeInsurance,
        ordinaryPayment
      } = tableRow;

      if (paymentNumber === 0) { continue; }
      table.push([
        paymentNumber,
        moment(paymentDate).format('DD/MM/YYYY'),
        this.formatText(capital),
        this.formatText(interest),
        this.formatText(interestWithIva),
        this.formatText(amortization),
        this.formatText(lifeInsurance),
        this.formatText(ordinaryPayment),
      ]);
    }

    return table;
  }



  private getBodyDetails(): TableCell[][] {
    return [
      [{ text: 'DETALLE DE SERVICIOS', alignment: 'center' }],
      [
        {
          text: [
            // this.getCellCss('Mantenimiento: ', '#000', '#fff', true),
            // mantenance,

            this.getCellCss('Rastreo Base: ', '#000', '#fff', true),
            tracking,

            this.getCellCss('Protección Plus: ', '#000', '#fff', true),
            protectPlus,

            this.getCellCss('Seguro Automotriz: ', '#000', '#fff', true),
            secure,

            this.getCellCss(
              'Tipo de Auto para Auto Sustituto: ',
              '#000',
              '#fff',
              true
            ),
            substitute,

            this.getCellCss('Seguro Personal: ', '#000', '#fff', true),
            personalSecure,
          ],
          alignment: 'justify',
        },
      ],
    ];
  }

  private getBodyNotes(): TableCell[][] {
    const text = `${textNotes} \nCAT del ${(this.deadlineSelect.cat * 100).toFixed(2)}% sin IVA calculado el ${this.quoterDate
      }. Para fines informativos y de comparación exclusivamente.`;
    return [
      [{ text: 'NOTAS', alignment: 'center' }],
      [
        {
          text,
          alignment: 'justify',
        },
      ],
    ];
  }

  private getPdfBase64(): Promise<string> {
    return new Promise((resolve) => {
      this.pdfOpen?.getBase64((base64) => resolve(base64));
    });
  }
}
